module.exports = __webpack_public_path__ + "img/MicrosoftTeams-image (8).37910e2d.png";